module.exports = "<app-navbar></app-navbar>\n<router-outlet></router-outlet>\n<footer></footer>\n"


//////////////////
// WEBPACK FOOTER
// /Users/BenLeech/portfolio-website/portfolio-website/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1